import { render, staticRenderFns } from "./OrderOverviewCart.vue?vue&type=template&id=37b36235&scoped=true"
import script from "./OrderOverviewCart.vue?vue&type=script&lang=js"
export * from "./OrderOverviewCart.vue?vue&type=script&lang=js"
import style0 from "./OrderOverviewCart.vue?vue&type=style&index=0&id=37b36235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b36235",
  null
  
)

export default component.exports